import React, { useCallback } from 'react';

import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import IconButton from '@mui/material/IconButton';

import ReorderIcon from '@mui/icons-material/Reorder';
import DeleteIcon from '@mui/icons-material/Delete';

import { Exercise } from 'modules/exercises/types';

interface SelectedExerciseListItemProps {
  exercise?: Exercise;
  onRemoveExercise?: (exercise: Exercise) => void;
}

const SelectedExerciseListItem = (props: SelectedExerciseListItemProps) => {
  const { exercise, onRemoveExercise } = props;

  const handleRemoveExercise = useCallback(() => {
    if (exercise && onRemoveExercise) {
      onRemoveExercise(exercise);
    }
  }, [exercise, onRemoveExercise]);

  if (!exercise) {
    return <span />;
  }

  return (
    <ListItem sx={{ bgcolor: 'white' }}>
      <ListItemIcon>
        <ReorderIcon />
      </ListItemIcon>
      <ListItemText primary={exercise.code} />
      <ListItemSecondaryAction>
        {onRemoveExercise && (
          <IconButton onClick={handleRemoveExercise} size="large">
            <DeleteIcon />
          </IconButton>
        )}
      </ListItemSecondaryAction>
    </ListItem>
  );
};

export default SelectedExerciseListItem;
